import {
    FETCH_LOCK_NUMBER_BY_USER,
    LIST_LOCK_NUMBER_BY_USER,
    MODIFY_LOCK_NUMBER_BY_USER,
    CLEAR_LIST_LOCK_NUMBER
} from "./types";

const init = {
    isLoading: false,
    filter: {},
    data: {
        items: [],
        defaultItems: [],
        allMember: []
    }
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_LOCK_NUMBER_BY_USER:
            return {
                ...state,
                filter: payload,
                isLoading: true
            };
        case LIST_LOCK_NUMBER_BY_USER:
            return {
                ...state,
                isLoading: false,
                data: payload
            };
        case MODIFY_LOCK_NUMBER_BY_USER:
            return {
                ...state,
                isLoading: true
            };
        case CLEAR_LIST_LOCK_NUMBER:
            return {
                ...state,
                data: [],
                isLoading: false
            };
        default:
            return state;
    }
}
